import { createRxDatabase } from 'rxdb/plugins/core';
import { getRxStorageDexie } from 'rxdb/plugins/storage-dexie';
import { pocketCollections } from './collections';

let dbPromise = null;

export async function getPocketDB() {
  if (!dbPromise) {
    dbPromise = (async () => {
      try {
        const db = await createRxDatabase({
          name: 'pocket_parliamentarian_v2',
          storage: getRxStorageDexie(),
          multiInstance: false,
        });
        await db.addCollections(pocketCollections);
        return db;
      } catch (err) {
        dbPromise = null;
        throw err;
      }
    })();
  }
  return dbPromise;
}
